import React, { useState } from 'react';
import './CauHoiThuongGap.css';

const CauHoiThuongGap = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: 'Có cần nạp tiền để chơi không?',
      answer: 'KHÔNG! Bạn hoàn toàn chơi miễn phí. Mỗi ngày bạn được 1 lượt quay số miễn phí, không cần nạp tiền, không cần thẻ tín dụng. Chỉ cần đăng ký bằng số điện thoại là có thể quay ngay. Nếu muốn tăng cơ hội trúng, bạn có thể mua thêm lượt quay, nhưng không bắt buộc.'
    },
    {
      question: 'Rút tiền như thế nào? Có mất phí không?',
      answer: 'Sau khi trúng thưởng, tiền sẽ tự động vào ví của bạn. Bạn có thể rút về: (1) Tài khoản ngân hàng (Vietcombank, BIDV, Techcombank, Vietinbank...), (2) Ví điện tử (Momo, ZaloPay, ShopeePay). Thời gian xử lý: 5-10 phút. Phí rút tiền: HOÀN TOÀN MIỄN PHÍ cho lần rút đầu tiên, các lần sau chỉ 2% (tối thiểu 5,000đ).'
    },
    {
      question: 'Game này có uy tín và an toàn không?',
      answer: 'Rất uy tín và an toàn! Chúng tôi: (1) Được cấp phép hoạt động hợp pháp, (2) Sử dụng công nghệ bảo mật SSL 256-bit, (3) Mã hóa toàn bộ thông tin người chơi, (4) Có đội ngũ hỗ trợ 24/7 qua Zalo, Facebook, (5) Đã trao hơn 15 tỷ đồng giải thưởng cho 250,000+ người chơi. Bạn có thể yên tâm!'
    },
    {
      question: 'Tỷ lệ trúng thưởng thực tế là bao nhiêu?',
      answer: 'Tỷ lệ trúng thưởng của chúng tôi là 12.5% (tức là 1/8 người chơi sẽ trúng). Cụ thể: Giải đặc biệt 10 triệu (0.1%), Giải nhất 5 triệu (0.5%), Giải nhì 1 triệu (2%), Giải ba 500k (5%), Giải khuyến khích 100-500k (5%). Đây là tỷ lệ minh bạch và cao hơn nhiều so với các game may mắn khác trên thị trường.'
    },
    {
      question: 'Mỗi ngày được quay bao nhiêu lần?',
      answer: 'Mỗi ngày bạn được 1 lượt quay MIỄN PHÍ. Nếu muốn tăng cơ hội trúng, bạn có thể mua thêm lượt quay với giá: 10,000đ/lượt (mua 5 lượt), 8,000đ/lượt (mua 10 lượt), 5,000đ/lượt (mua 20 lượt). Lưu ý: Chỉ mua thêm khi bạn muốn, không bắt buộc.'
    },
    {
      question: 'Đăng ký và chơi như thế nào?',
      answer: 'Rất đơn giản: (1) Nhập số điện thoại vào form trên trang chủ, (2) Nhận mã OTP qua SMS và nhập để xác thực, (3) Hoàn tất đăng ký trong 30 giây, (4) Click "Quay Ngay" để bắt đầu vòng quay may mắn, (5) Nếu trúng, tiền tự động vào ví. Toàn bộ quá trình chỉ mất 1-2 phút!'
    },
    {
      question: 'Nếu trúng thưởng, tôi có thể rút ngay không?',
      answer: 'CÓ! Bạn có thể rút ngay lập tức. Không có thời gian chờ, không cần đạt điều kiện gì. Trúng bao nhiêu rút bấy nhiêu. Số tiền tối thiểu để rút là 50,000đ. Ví dụ: Trúng 100,000đ → Rút ngay về Momo trong 5 phút. Trúng 10 triệu → Rút về ngân hàng trong 10 phút.'
    },
    {
      question: 'Game này có lừa đảo không? Có ai thực sự trúng không?',
      answer: 'HOÀN TOÀN KHÔNG LỪA ĐẢO! Chúng tôi đã hoạt động hơn 2 năm, đã trao hơn 15 tỷ đồng cho 250,000+ người chơi. Bạn có thể xem danh sách người thắng gần đây ở phần "Người thắng gần đây" trên trang. Nhiều người đã trúng và rút tiền thành công, bạn có thể kiểm chứng qua các review thật trên Facebook, Zalo của chúng tôi.'
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="faq">
      <div className="container">
        <h2 className="section-title">Câu Hỏi Thường Gặp</h2>
        <p className="section-subtitle">Giải đáp mọi thắc mắc của bạn</p>
        
        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div key={index} className={`faq-item ${openIndex === index ? 'open' : ''}`}>
              <button 
                className="faq-question" 
                onClick={() => toggleFAQ(index)}
                aria-expanded={openIndex === index}
                aria-controls={`faq-answer-${index}`}
              >
                <span>{faq.question}</span>
                <span className="faq-icon" aria-hidden="true">{openIndex === index ? '−' : '+'}</span>
              </button>
              <div className="faq-answer" id={`faq-answer-${index}`} role="region">
                <p>{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CauHoiThuongGap;

